import React from 'react';
// import LoginPhoneInput from '../../../../../../common/inputs/AuthorizationInputs';
// todo вернул пока подключение из PhoneInput так как в AuthorizationInputs происходит ошибка, нужно разобраться в чем причина
import LoginPhoneInput from '../../../../../../common/inputs/AuthorizationInputs';
import { Form, Select, Popover, Icon } from 'antd';
const Option = Select.Option;

const Phone = ({
  isEditable,
  validateField,
  form,
  checkIsLoading,
  typeForm,
}) => {
  const { getFieldDecorator, getFieldValue } = form;
  const validatePhone = validateField('phone');
  const isDriver = getFieldValue('roleKey') === 'driver';
  return (
    <div className="b-form-fields">
      <div className="b-form-fields__item">
        <div className="form-item-phone">
          <Form.Item
            label="Номер телефона"
            validateStatus={
              checkIsLoading ? 'validating' : validatePhone.status
            }
            hasFeedback={checkIsLoading}
            help={validatePhone.help}
          >
            {getFieldDecorator('phone', {
              rules: [
                {
                  required: true,
                  message: 'Поле, обязательное для заполнения',
                },
              ],
            })(
              <LoginPhoneInput
                addonBefore={getFieldDecorator('phoneCode', {
                  initialValue: '+7',
                  rules: [
                    {
                      required: true,
                      message: 'Поле, обязательное для заполнения',
                    },
                  ],
                })(
                  <Select
                    style={{ width: 80 }}
                    name="phoneCode"
                    disabled={!isEditable}
                    dropdownMenuStyle={{ width: '180px' }}
                    dropdownMatchSelectWidth={false}
                    optionLabelProp="value"
                    getPopupContainer={trigger => trigger.parentNode}
                  >
                    <Option value="+7" label="+7 (Россия)">
                      +7 (Россия)
                    </Option>
                    <Option value="+380">+380 (Украина)</Option>
                    <Option value="+375">+375 (Беларусь)</Option>
                    <Option value="+77">+77 (Казахстан)</Option>
                    <Option value="+994">+994 (Азербайджан)</Option>
                    <Option value="+374">+374 (Армения)</Option>
                    <Option value="+995">+995 (Грузия)</Option>
                  </Select>
                )}
                name="phone"
                mask="(###) ###-##-##"
                style={{ width: 320 }}
                maxLength={15}
                placeholder="Номер телефона"
                disabled={!isEditable}
              />
            )}
            {isDriver && typeForm === 'create' && (
              <Popover
                title="Запрос на сотрудничество"
                placement="topLeft"
                content={
                  <div style={{ width: 272 }}>
                    Водителю на данный номер
                    <br /> телефона будет отправлен запрос
                    <br />
                    на сотрудничество и ссылка
                    <br />
                    на мобильное приложение. После
                    <br /> принятия предложения вы сможете
                    <br /> назначать водителя на любые заказы
                    <br /> аккаунта.
                  </div>
                }
                trigger="click"
                className="requestСooperationPopup"
                // visible={this.state.visible_popover_auto_services}
                // onVisibleChange={e =>
                //   this.handle_visible_popover_auto_services(e)
                // }
              >
                <Icon type="question-circle" />
              </Popover>
            )}
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default Phone;
